import { defineComponent as _defineComponent } from 'vue'
import { useIsDesktop } from "@/features/useIsDesktop";

  interface Props {
    instructions: {
      title: string;
      description: string;
    };
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'SelectionInstruction',
  props: {
    instructions: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const { isDesktop } = useIsDesktop(990);

  const props = __props;

const __returned__ = { isDesktop, props, get useIsDesktop() { return useIsDesktop } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})